import { useState } from "react";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import JuicyButton from "@/components/base/JuicyButton";

const faqs = [
  {
    q: "無料で使えますか？",
    a: "はい、時間割くんは完全無料でご利用いただけます。",
  },
  {
    q: "どうやって時間割を登録するの？",
    a: "現在はBotに時間割データが設定されています。カスタム登録機能は今後追加予定です。",
  },
  {
    q: "スマートフォンのDiscordでも使えますか？",
    a: "はい。スマートフォン・PC・タブレットなど、Discordが使えるすべての端末で利用できます。",
  },
  {
    q: "サーバーの管理者権限が必要ですか？",
    a: "Botを追加するには「サーバーの管理」権限が必要です。追加後はメンバー全員が使えます。",
  },
  {
    q: "うまく動かない場合はどうすればいい？",
    a: "/help コマンドを試してみてください。それでも解決しない場合はサポートサーバーへどうぞ。",
  },
];

export default function SupportSection() {
  const { ref: headRef, visible: headVisible } = useScrollReveal();
  const { ref: faqRef, visible: faqVisible } = useScrollReveal();

  return (
    <section id="support" className="py-32 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <p className="text-xs font-semibold tracking-[0.2em] uppercase text-gray-400 mb-4">サポート</p>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          <div
            ref={headRef}
            style={{
              opacity: headVisible ? 1 : 0,
              transform: headVisible ? "translateY(0)" : "translateY(30px)",
              transition: "opacity 0.8s ease-out, transform 0.8s ease-out",
            }}
          >
            <h2 className="text-4xl md:text-5xl font-black text-black leading-tight mb-6">
              よくある<br />ご質問
            </h2>
            <p className="text-gray-500 text-sm leading-relaxed mb-8">
              解決しない場合はDiscordサポートサーバーへお気軽にどうぞ。
            </p>
            <JuicyButton
              as="a"
              href="https://discord.gg/"
              target="_blank"
              rel="noopener noreferrer"
              particleColor="#ffffff"
              className="inline-flex items-center gap-2 bg-black text-white text-sm font-medium px-6 py-3 rounded-full whitespace-nowrap cursor-pointer hover:bg-gray-800 transition-colors"
            >
              <i className="ri-discord-fill"></i>
              サポートサーバーへ
            </JuicyButton>
          </div>

          <div
            ref={faqRef}
            className="flex flex-col divide-y divide-gray-100"
            style={{
              opacity: faqVisible ? 1 : 0,
              transform: faqVisible ? "translateY(0)" : "translateY(20px)",
              transition: "opacity 0.8s ease-out 0.15s, transform 0.8s ease-out 0.15s",
            }}
          >
            {faqs.map((faq) => (
              <FAQItem key={faq.q} q={faq.q} a={faq.a} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function FAQItem({ q, a }: { q: string; a: string }) {
  const [open, setOpen] = useState(false);
  return (
    <div
      className="py-5 cursor-pointer group"
      onClick={() => setOpen(!open)}
    >
      <div className="flex items-center justify-between gap-4">
        <span className="text-black font-medium text-sm group-hover:text-gray-600 transition-colors">{q}</span>
        <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
          <i className={`${open ? "ri-subtract-line" : "ri-add-line"} text-gray-400 text-base`}></i>
        </div>
      </div>
      {open && (
        <p className="text-gray-500 text-sm leading-relaxed mt-3 pr-8">{a}</p>
      )}
    </div>
  );
}
